import { Fragment } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export type BreadcrumbLink = {
  to: string;
  label: string;
};

type BreadcrumbsProps = {
  current: string;
  links: BreadcrumbLink[];
};

export function Breadcrumbs({ links, current }: BreadcrumbsProps) {
  const { t } = useTranslation('common');

  return (
    <nav className="breadcrumbs" aria-label={t('labels.breadcrumbs')}>
      {links.map((link) => (
        <Fragment key={link.to}>
          <Link to={link.to}>{link.label}</Link>
          <span> / </span>
        </Fragment>
      ))}
      {current}
    </nav>
  );
}
